/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {ActiveTemplateRequest} from '../models/ActiveTemplateRequest';
import type {Error} from '../models/Error';
import type {SearchType} from '../models/SearchType';
import type {UserSearchTemplate} from '../models/UserSearchTemplate';

export interface GetUserActiveTemplates$Request {
    userId: number;
    searchType: SearchType;
}

export interface GetUserActiveTemplates$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getUserActiveTemplatesRequest = createAction<PayloadData<void, GetUserActiveTemplates$Request>>('USER_SEARCH_TEMPLATE__GET_USER_ACTIVE_TEMPLATES__REQUEST');
export const getUserActiveTemplatesSuccess = createAction<PayloadData<UserSearchTemplate, GetUserActiveTemplates$Request>>('USER_SEARCH_TEMPLATE__GET_USER_ACTIVE_TEMPLATES__SUCCESS');
export const getUserActiveTemplatesFailure = createAction<PayloadData<Error, GetUserActiveTemplates$Request, true>>('USER_SEARCH_TEMPLATE__GET_USER_ACTIVE_TEMPLATES__FAILURE');

export const getUserActiveTemplatesActions = [
    getUserActiveTemplatesRequest,
    getUserActiveTemplatesSuccess,
    getUserActiveTemplatesFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {SearchType} meta.searchType
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getUserActiveTemplates = (meta: GetUserActiveTemplates$Request, config?: GetUserActiveTemplates$Config) => {
    const TRANSPORT_GET_PARAMS = {
        searchType: meta.searchType,
    };
    return {
        CALL_API: {
            types: getUserActiveTemplatesActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/users/${meta.userId}/search-templates/active`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetUserTemplates$Request {
    userId: number;
}

export interface GetUserTemplates$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getUserTemplatesRequest = createAction<PayloadData<void, GetUserTemplates$Request>>('USER_SEARCH_TEMPLATE__GET_USER_TEMPLATES__REQUEST');
export const getUserTemplatesSuccess = createAction<PayloadData<Array<UserSearchTemplate>, GetUserTemplates$Request>>('USER_SEARCH_TEMPLATE__GET_USER_TEMPLATES__SUCCESS');
export const getUserTemplatesFailure = createAction<PayloadData<Error, GetUserTemplates$Request, true>>('USER_SEARCH_TEMPLATE__GET_USER_TEMPLATES__FAILURE');

export const getUserTemplatesActions = [
    getUserTemplatesRequest,
    getUserTemplatesSuccess,
    getUserTemplatesFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getUserTemplates = (meta: GetUserTemplates$Request, config?: GetUserTemplates$Config) => {
    return {
        CALL_API: {
            types: getUserTemplatesActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/users/${meta.userId}/search-templates`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface SetUserActiveTemplate$Request {
    userId: number;
    activeTemplateRequest?: ActiveTemplateRequest;
}

export interface SetUserActiveTemplate$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const setUserActiveTemplateRequest = createAction<PayloadData<void, SetUserActiveTemplate$Request>>('USER_SEARCH_TEMPLATE__SET_USER_ACTIVE_TEMPLATE__REQUEST');
export const setUserActiveTemplateSuccess = createAction<PayloadData<void, SetUserActiveTemplate$Request>>('USER_SEARCH_TEMPLATE__SET_USER_ACTIVE_TEMPLATE__SUCCESS');
export const setUserActiveTemplateFailure = createAction<PayloadData<Error, SetUserActiveTemplate$Request, true>>('USER_SEARCH_TEMPLATE__SET_USER_ACTIVE_TEMPLATE__FAILURE');

export const setUserActiveTemplateActions = [
    setUserActiveTemplateRequest,
    setUserActiveTemplateSuccess,
    setUserActiveTemplateFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {ActiveTemplateRequest} [meta.activeTemplateRequest]
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const setUserActiveTemplate = (meta: SetUserActiveTemplate$Request, config?: SetUserActiveTemplate$Config) => {
    return {
        CALL_API: {
            types: setUserActiveTemplateActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/users/${meta.userId}/search-templates/active`,
            TRANSPORT_REQUEST_BODY: meta.activeTemplateRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

